module.exports = __webpack_public_path__ + "static/media/persona1.ee378b00.png";